module.exports = __webpack_public_path__ + "img/positive.c8af154b.png";